import { Skeleton, Stack, SxProps, Theme } from "@mui/material";
import { SenecCard } from "src/components/cards/base/SenecCard";
import { useScreenSize } from "src/hooks/useScreenSize";
import { PropsWithChildren } from "react";

export interface SenecTileProps {
    isLoading?: boolean;
    sx?: SxProps<Theme>;
}

export const SenecTile = ({ isLoading, sx, children }: PropsWithChildren<SenecTileProps>) => {
    const { isMobile } = useScreenSize();

    return isLoading ? (
        <Skeleton data-testid="skeleton" variant="rounded" sx={{ borderRadius: "0.75rem" }} width="100%" height="150px" />
    ) : (
        <SenecCard data-testid="grouped-tile" sx={{ height: "100%", ...sx }}>
            <Stack spacing={isMobile ? 3 : 4}>{children}</Stack>
        </SenecCard>
    );
};
